module.exports = __webpack_public_path__ + "static/media/data-center-engineers.2638fb63.gif";